import PropTypes from "prop-types";

import {
  Tab,
  Tabs,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Stack,
  Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

import "../styles.css";
import AccordionSummaryTitle from "../AccordionSummaryTitle";

import { ReactComponent as IconVaccination } from "../../../../images/iconVaccination.svg";

import Laboratorio from "./Tab/Laboratorio";
import OutrosExames from "./Tab/OutrosExames";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ padding: "16px 0px" }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const handleProgressForm = (data) => {
  const fieldHide = "*";

  const fields = [
    data.examesPredefinidosExamesEProcedimentos[0] ?? "",
    data.outrosExamesLaboratoriais[0] ?? "",
    data.examesLaboratoriaisObservacao ?? "",
    data.solicitacaoOutrosExames.length > 0 ? "tem" : "",
  ];

  if (fields.every((campo) => campo !== "")) {
    return "full";
  } else if (fields.some((campo) => campo !== "" && campo !== fieldHide)) {
    return "partial";
  } else {
    return "empty";
  }
};

export default function ExamesProcedimentos({
  expanded,
  handleChangePanel,
  value,
  handleChange,
  onSubmit,
  data,
  setData,
  handleExamesPredefinidosOptions,
  examesPredefinidosOptions,
  handleCheckedField,
  examesPredefinidosList,
  small,
  readOnly,
}) {
  const progressForm = handleProgressForm(data);

  return (
    <Accordion
      defaultExpanded={false}
      {...(!readOnly && {
        expanded: expanded === "examesProcedimentos",
        onChange: handleChangePanel("examesProcedimentos"),
      })}
      // expanded={expanded === "examesProcedimentos"}
      // onChange={handleChangePanel("examesProcedimentos")}
      sx={{ mb: 2 }}
      className="AccordionContainer"
    >
      <AccordionSummary
        expandIcon={<ExpandMore style={{ color: "#1E729F" }} />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        className={`AccordionSummaryContainer ${small ? "small" : ""}`}
      >
        {readOnly ? (
          <Stack direction="row" alignItems="center" gap="8px " height="30px">
            <IconVaccination style={{ width: "24px" }} />
            <Typography className="Accordion_title small">
              Exames e procedimentos
            </Typography>
          </Stack>
        ) : (
          <AccordionSummaryTitle
            title="Exames e procedimentos"
            icon={<IconVaccination style={{ width: "24px" }} />}
            progressForm={progressForm}
          />
        )}
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            TabIndicatorProps={{
              style: {
                background: "#1E729F",
              },
            }}
            sx={{
              fontFamily: "Nunito",
              fontWeight: 400,
              ".Mui-selected": {
                color: "#1E729F",
                fontWeight: "700 !important",
              },
            }}
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="Laboratorial" {...a11yProps(0)} className="tabTitle" />
            <Tab label="Outros exames" {...a11yProps(1)} className="tabTitle" />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <Laboratorio
            onSubmit={onSubmit}
            data={data}
            setData={setData}
            handleExamesPredefinidosOptions={handleExamesPredefinidosOptions}
            examesPredefinidosOptions={examesPredefinidosOptions}
            handleCheckedField={handleCheckedField}
            examesPredefinidosList={examesPredefinidosList}
            readOnly={readOnly}
          />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <OutrosExames
            onSubmit={onSubmit}
            data={data}
            setData={setData}
            readOnly={readOnly}
          />
        </CustomTabPanel>
      </AccordionDetails>
    </Accordion>
  );
}
